module.exports = __webpack_public_path__ + "img/Slice13-min.c44579d1.png";